import { forwardRef } from 'react';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { sanitizePhoneNumber } from '../../../utils/personFieldValidation';

const PhoneNumberField = forwardRef<HTMLInputElement, TextFieldProps>(function PhoneNumberField(
  { onChange, inputRef, inputProps, ...props },
  ref,
) {
  return (
    <TextField
      {...props}
      inputRef={inputRef || ref}
      inputProps={{
        inputMode: 'numeric',
        autoComplete: 'tel',
        ...inputProps,
      }}
      onChange={(e) => {
        const sanitized = sanitizePhoneNumber(e.target.value);
        if (e.target.value !== sanitized) e.target.value = sanitized;
        onChange?.(e);
      }}
    />
  );
});

export default PhoneNumberField;
